import { Injectable, EventEmitter } from '@angular/core';
import { GroupByTournamentId } from '@pipes/grouplivefixturebytournamentid';
import { BehaviorSubject } from 'rxjs';
import { DefaultSlipAmount, environment } from '@environments/environment';
import { GroupByEventName } from '@pipes/groupbyeventname.pipe';
import { DomSanitizer } from '@angular/platform-browser';
import { GroupedDataItem } from '@app/models/mostTicket.model';
import { sideBannerItemType } from '@components/slider/sideBanner/side-banner-slider.model';
import { any } from 'codelyzer/util/function';
import { de } from 'date-fns/esm/locale';

declare let betaluxBr;
declare let seon;
interface ISelectedWallet {
  CustomerId: number;
  BranchId: number;
  BranchType: number;
  BrancName: string;
  Balance: number;
  ExtensionData: object;
  IsVerification: boolean;
  IsResetActive: boolean;
  TaxRate: number;
  IsShufa: boolean;
  IsFin: boolean;
  IsFreeBetBonus: boolean;
  IsBoostBonus: boolean;
}

export interface ICustomerBonus {
  BonusRate: number;
  MaxAmount: number;
  MaxOddValue: number;
  MinAmount: number;
  MinEventCount: number;
  MinEventCount1: number;
  MinOddValue: number;
  EndDate: string;
  BonusAmount: number;
}

@Injectable({
  providedIn: 'root',
})
export class DataHelper {
  public favList: number[] = [];
  public favListListener: EventEmitter<any> = new EventEmitter();
  public favFixtureList: any[] = [];
  public favDisabledMatchId: any[] = [];
  public setFavListListener: EventEmitter<any> = new EventEmitter();
  mostPlayedTicketData: Array<GroupedDataItem>;

  preMatchobservable = new BehaviorSubject<any>([]);

  oldCouponList = [];
  selectedWallet: ISelectedWallet = {
    CustomerId: 0,
    BranchId: 0,
    BranchType: 0,
    BrancName: '',
    Balance: 0,
    ExtensionData: {},
    IsVerification: true,
    TaxRate: 0,
    IsShufa: false,
    IsFin: false,
    IsResetActive: false,
    IsFreeBetBonus: false,
    IsBoostBonus: false,
  };
  customerBoostBonusInfo: ICustomerBonus;
  customerFreeBetBonusInfo: ICustomerBonus;

  isSelectOdd = false;
  default_stake_amount = { amount_default_price: 2, amount_id: 0, amount_value: 2 };
  default_amount_arr = [
    {
      amount_default_price: 10,
      amount_id: 1,
      amount_value: 10,
    },
    {
      amount_default_price: 20,
      amount_id: 2,
      amount_value: 20,
    },
    {
      amount_default_price: 25,
      amount_id: 3,
      amount_value: 25,
    },
    {
      amount_default_price: 50,
      amount_id: 4,
      amount_value: 50,
    },
    {
      amount_default_price: 100,
      amount_id: 5,
      amount_value: 100,
    },
  ];
  // May be shop value change next time.Now 1;
  isOutRights;
  selectedStoryItem;
  liveHeaderTitle;
  selectedStorySportId = 1; // 1 = Soccer
  selectedStoryIndex = 0; // Index => 0 Soccer
  selectedStorySportAllItem = { OrginalName: 'Soccer', SportName: 'Soccer' };
  comboSelectedOdd = { OddId: 0, OddNameLong: 'tipp_long', OddNameLong2: '', OddName: 'tipp', OddTitles: ['1', 'X', '2'] };
  allSportsMenuSelectedTimeFilter = 300;

  liveMatchFilter: 'time' | 'league' = 'league';
  liveMatchFilterListener: EventEmitter<'time' | 'league'> = new EventEmitter();

  sliderList: sideBannerItemType[];

  selectedMatch: any;

  mySlipMatchListListener: EventEmitter<any> = new EventEmitter();
  mySlipMatchListApiCallListener: EventEmitter<any> = new EventEmitter();
  mySlipMatchList: number[];
  isMySlipButton = false;
  isMySlipButtonListener: EventEmitter<any> = new EventEmitter();

  // Routing kalktığı için type tutuldu.1 eventdetail 2 livedetail
  LeagueDataListener: EventEmitter<any> = new EventEmitter();
  LeagueData: Array<any>;
  leftMenuSportDataListener: EventEmitter<any> = new EventEmitter();
  leftMenuSportData: Array<any>;
  leftMenuSportDayFilter: number;
  searchDataListener: EventEmitter<any> = new EventEmitter();
  searchDataUrlListener: EventEmitter<any> = new EventEmitter();
  searchData: Array<any>;
  liveData: Array<any> = [];
  liveDataListener: EventEmitter<any> = new EventEmitter();
  cardData: Array<any>;
  cardDataListener: EventEmitter<any> = new EventEmitter();
  liveEventDetailData: Array<any>;
  liveEventDetailListener: EventEmitter<any> = new EventEmitter();
  qrCodeBookBetBody;
  bookBetsReserveList: Array<any>;
  bookBetsReserveListener: EventEmitter<any> = new EventEmitter();

  liveEventDataRebuildedListener: EventEmitter<any> = new EventEmitter();
  liveEventDataRebuilded;

  liveFilterItemsListener: EventEmitter<any> = new EventEmitter();
  liveFilterItems;
  liveSortbyTime = false;

  currentSlipDataListener: EventEmitter<any> = new EventEmitter();
  currentSlipData: Array<any> = [];

  numberOfBetsListener: EventEmitter<any> = new EventEmitter();
  numberOfBets: any;
  taxRate = 0;

  currentSlipOpened = false;

  groupByTournamentId = new GroupByTournamentId();
  cashoutDataListener: EventEmitter<any> = new EventEmitter();
  cashoutData: Array<any>;

  numberOfCashoutListener: EventEmitter<any> = new EventEmitter();
  numberOfCashout: any;

  DataCustomerTicketList = [];
  DataCustomerTicketDetailList = [];

  ChangeOddIsActive = true;

  liveFavoriteTournamentList: Array<any> = [];

  liveFavoriteButtonStatus = false;

  liveFavouriteStateChanged: EventEmitter<any> = new EventEmitter();

  homeHighlightsFixture = new BehaviorSubject<any>([]);
  homeSliderData = [];
  homeSliderDataListener: EventEmitter<any> = new EventEmitter();

  currentSlipAmount: any;
  currentSlipAmountListener: EventEmitter<any> = new EventEmitter();

  currentSlipSystemInfo: any = [];
  currentSlipSystemInfoListener: EventEmitter<any> = new EventEmitter();

  /**
   * @desc: Betting slip system bet selections
   */
  currentSlipSystemSelection: any = [];
  currentSlipVorabTicket: any = [];
  currentSlipVorabOdd: any = [];

  cashoutSlipsList: any = [];
  oldCashoutSlipsList: any = [];

  cashoutTimeLineData: { [key: number]: any } = {};

  liveMatchobservable = new BehaviorSubject<any>(this.liveData);
  liveSportsData = [];
  setSelectedTVTab = true;
  public currentSlipInfo = {
    toPay: 0,
    toPayNumeric: 0,
    currentslip_totalStake: DefaultSlipAmount,
    currentTotalRate: 0,
    tax: '',
    amountPerBet: 0,
    numberOfBets: 0,
    maxGain: 0,
    minGain: 0,
    totalRate: 0,
    oddIsChange: false,
    isMultiWaySystem: false,
    isCheckIsSystem: false,
    maxWinTax: '',
    OldTotalRate: 0,
  };

  comparisonData = [];
  comparisonDataListener: EventEmitter<any> = new EventEmitter();
  topWinnerData = {
    1: [],
    2: [],
    3: [],
  };
  topWinnerDataListener: EventEmitter<any> = new EventEmitter();
  topWinnerDataActiveTab = 1;
  homeMainData = [];
  mainData = [];
  storySportsData = [
    {
      imageUrl: 'basketball.svg',
      pngUrl: 'basketball.png',
      SportName: 'Basketball',
      selected: false,
    },
    {
      imageUrl: 'soccer.svg',
      pngUrl: 'soccer.png',
      SportName: 'Soccer',
      selected: false,
    },
    {
      imageUrl: 'baseball.svg',
      pngUrl: 'baseball.png',
      SportName: 'Baseball',
      selected: false,
    },
    {
      imageUrl: 'football.svg',
      pngUrl: 'football.png',
      SportName: 'Football',
      selected: false,
    },
    {
      imageUrl: 'tennis.svg',
      pngUrl: 'tennis.png',
      SportName: 'Tennis',
      selected: false,
    },
    {
      imageUrl: 'volleyball.svg',
      pngUrl: 'volleyball.png',
      SportName: 'Volleyball',
      selected: false,
    },
    {
      imageUrl: 'icehokey.svg',
      pngUrl: 'icehockey.png',
      SportName: 'Ice Hockey',
      selected: false,
    },
    {
      imageUrl: 'handball.svg',
      pngUrl: 'handball.png',
      SportName: 'Handball',
      selected: false,
    },
    {
      imageUrl: 'rugby.svg',
      pngUrl: 'rugby.png',
      SportName: 'Rugby',
      selected: false,
    },
    {
      imageUrl: 'aussierules.svg',
      pngUrl: 'aussierules.png',
      SportName: 'Aussie rules',
      selected: false,
    },
    {
      imageUrl: 'snooker.svg',
      pngUrl: 'snooker.png',
      SportName: 'Snooker',
      selected: false,
    },
    {
      imageUrl: 'tabletennis.svg',
      pngUrl: 'tabletennis.png',
      SportName: 'Table tennis',
      selected: false,
    },
    {
      imageUrl: 'cricket.svg',
      pngUrl: 'cricket.png',
      SportName: 'Cricket',
      selected: false,
    },
    {
      imageUrl: 'darts.svg',
      pngUrl: 'darts.png',
      SportName: 'Darts',
      selected: false,
    },
    {
      imageUrl: 'futsal.svg',
      pngUrl: 'futsal.png',
      SportName: 'Futsal',
      selected: false,
    },
    {
      imageUrl: 'badminton.svg',
      pngUrl: 'badminton.png',
      SportName: 'Badminton',
      selected: false,
    },
    {
      imageUrl: 'bowls.svg',
      pngUrl: 'bowls.png',
      SportName: 'Bowls',
      selected: false,
    },
    {
      imageUrl: 'beachvolley.svg',
      pngUrl: 'beachvolley.png',
      SportName: 'Beach Volley',
      selected: false,
    },
    {
      imageUrl: 'squash.svg',
      pngUrl: 'squash.png',
      SportName: 'Squash',
      selected: false,
    },
    {
      imageUrl: 'csgo.svg',
      pngUrl: 'csgo.png',
      SportName: 'ESport Counter-Strike', //  CS:GO
      selected: false,
    },
    {
      imageUrl: 'lol.svg',
      pngUrl: 'lol.png',
      SportName: 'ESport League of Legends', // LOL
      selected: false,
    },
    {
      imageUrl: 'dota2.svg',
      pngUrl: 'dota2.png',
      SportName: 'DOTA 2',
      selected: false,
    },
    {
      imageUrl: 'motorsport.svg',
      pngUrl: 'motorsport.png',
      SportName: 'Motor sport',
      selected: false,
    },
    {
      imageUrl: 'boxing.svg',
      pngUrl: 'boxing.png',
      SportName: 'Boxing',
      selected: false,
    },
    {
      imageUrl: 'waterpolo.svg',
      pngUrl: 'waterpolo.png',
      SportName: 'Waterpolo',
      selected: false,
    },
    {
      imageUrl: 'icehokey.svg',
      pngUrl: 'icehockey.png',
      SportName: 'Field Hockey',
      selected: false,
    },
  ];

  oddTypes = [
    {
      // 0
      all: [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: 'x',
          type: '2',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      Tennis: [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      Basketball: [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      Boxing: [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      Badminton: [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      Football: [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      'Table tennis': [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      Volleyball: [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      Snooker: [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      'Motor sport': [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      Baseball: [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      Darts: [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      Alpine: [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      'Aussie rules': [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      Cricket: [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      'Cross-Country': [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      Curling: [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      Biathlon: [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      'Short Track Speed Skating': [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
    },
    {
      // 1
      all: [
        {
          preText: '1',
          type: 'Hadicap01_1',
          Gname: 'Handicap',
          line: '1',
          lineText: 'Hadicap01_1',
          set: { mLine: true, perLine: 3 },
        },
        {
          preText: 'X',
          type: 'Hadicap01_X',
          Gname: 'Handicap',
          lineText: 'Hadicap01_X',
          line: '1',
        },
        {
          preText: '2',
          type: 'Hadicap01_2',
          Gname: 'Handicap',
          line: '1',
          lineText: 'Hadicap01_2',
        },
        {
          preText: '1',
          type: 'Hadicap02_1',
          Gname: 'Handicap',
          lineText: 'Hadicap02_1',
          line: '2',
        },
        {
          preText: 'X',
          type: 'Hadicap02_X',
          Gname: 'Handicap',
          lineText: 'Hadicap02_X',
          line: '2',
        },
        {
          preText: '2',
          type: 'Hadicap02_2',
          Gname: 'Handicap',
          line: '2',
          lineText: 'Hadicap02_2',
        },
        {
          preText: '1',
          type: 'Hadicap10_1',
          Gname: 'Handicap',
          line: '3',
          lineText: 'Hadicap10_1',
        },
        {
          preText: 'X',
          type: 'Hadicap10_X',
          Gname: 'Handicap',
          line: '3',
          lineText: 'Hadicap10_X',
        },
        {
          preText: '2',
          type: 'Hadicap10_2',
          Gname: 'Handicap',
          line: '3',
          lineText: 'Hadicap10_2',
        },
        {
          preText: '1',
          type: 'Hadicap20_1',
          Gname: 'Handicap',
          lineText: 'Hadicap20_1',
          line: '4',
        },
        {
          preText: 'X',
          type: 'Hadicap20_X',
          Gname: 'Handicap',
          line: '4',
          lineText: 'Hadicap20_X',
        },
        {
          preText: '2',
          type: 'Hadicap20_2',
          Gname: 'Handicap',
          line: '4',
          lineText: 'Hadicap20_2',
        },
      ],
      Basketball: [
        {
          preText: '1',
          type: 'Hadicap01_1',
          Gname: 'Handicap',
          line: '1',
          lineText: 'Hadicap01_1',
          set: { mLine: true, perLine: 2 },
        },
        {
          preText: '2',
          type: 'Hadicap01_2',
          Gname: 'Handicap',
          line: '1',
        },
        {
          preText: '1',
          type: 'Hadicap02_1',
          Gname: 'Handicap',
          lineText: 'Hadicap02_1',
          line: '2',
        },
        {
          preText: '2',
          type: 'Hadicap02_2',
          Gname: 'Handicap',
          line: '2',
        },
        {
          preText: '1',
          type: 'Hadicap10_1',
          Gname: 'Handicap',
          lineText: 'Hadicap10_1',
          line: '3',
        },
        {
          preText: '2',
          type: 'Hadicap10_2',
          Gname: 'Handicap',
          line: '3',
        },
        {
          preText: '1',
          type: 'Hadicap20_1',
          Gname: 'Handicap',
          lineText: 'Hadicap20_1',
          line: '4',
        },
        {
          preText: '2',
          type: 'Hadicap20_2',
          Gname: 'Handicap',
          line: '4',
        },
      ],
      Baseball: [
        {
          preText: '1',
          type: 'Hadicap01_1',
          Gname: 'Handicap',
          line: '1',
          lineText: 'Hadicap01_1',
          set: { mLine: true, perLine: 2 },
        },
        {
          preText: '2',
          type: 'Hadicap01_2',
          Gname: 'Handicap',
          line: '1',
        },
        {
          preText: '1',
          type: 'Hadicap02_1',
          Gname: 'Handicap',
          lineText: 'Hadicap02_1',
          line: '2',
        },
        {
          preText: '2',
          type: 'Hadicap02_2',
          Gname: 'Handicap',
          line: '2',
        },
        {
          preText: '1',
          type: 'Hadicap10_1',
          Gname: 'Handicap',
          lineText: 'Hadicap10_1',
          line: '3',
        },
        {
          preText: '2',
          type: 'Hadicap10_2',
          Gname: 'Handicap',
          line: '3',
        },
        {
          preText: '1',
          type: 'Hadicap20_1',
          Gname: 'Handicap',
          lineText: 'Hadicap20_1',
          line: '4',
        },
        {
          preText: '2',
          type: 'Hadicap20_2',
          Gname: 'Handicap',
          line: '4',
        },
      ],
    },
    {
      // 2
      all: [
        {
          preTextT: 'Over_abrr',
          type: 'Totals_O1_5',
          Gname: 'Over/Under',
          line: '1',
          lineText: 'Totals_O1_5',
          set: { mLine: true, perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'Totals_U1_5',
          Gname: 'Over/Under',
          lineText: 'Totals_U1_5',

          line: '1',
        },
        {
          preTextT: 'Over_abrr',
          type: 'Totals_O2_5',
          Gname: 'Over/Under',
          lineText: 'Totals_O2_5',
          line: '2',
        },
        {
          preTextT: 'Under_abrr',
          type: 'Totals_U2_5',
          Gname: 'Over/Under',
          lineText: 'Totals_U2_5',

          line: '2',
        },
        {
          preTextT: 'Over_abrr',
          type: 'Totals_O3_5',
          Gname: 'Over/Under',
          lineText: 'Totals_O3_5',
          line: '3',
        },
        {
          preTextT: 'Under_abrr',
          type: 'Totals_U3_5',
          Gname: 'Over/Under',
          lineText: 'Totals_U3_5',

          line: '3',
        },
        {
          preTextT: 'Over_abrr',
          type: 'Totals_O4_5',
          Gname: 'Over/Under',
          lineText: 'Totals_O4_5',
          line: '4',
        },
        {
          preTextT: 'Under_abrr',
          type: 'Totals_U4_5',
          Gname: 'Over/Under',
          line: '4',
          lineText: 'Totals_U4_5',
        },
      ],
      Tennis: [
        {
          preTextT: 'Over_abrr',
          type: 'TennisTotal_O',
          Gname: 'Over/Under',
          line: '1',
          lineText: 'TennisTotal',
          set: { mLine: true, lineLeftText: 'TennisTotal', perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'TennisTotal_U',
          Gname: 'Over/Under',
          line: '1',
        },
      ],
      Basketball: [
        {
          preTextT: 'Over_abrr',
          type: 'Total1Over',
          Gname: 'Over/Under',
          line: '1',
          lineText: 'BasketTotal',
          set: { mLine: true, lineLeftText: 'TennisTotal', perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'Total1Under',
          Gname: 'Over/Under',
          line: '1',
        },
      ],
      Baseball: [
        {
          preTextT: 'Over_abrr',
          type: 'Total1Over',
          Gname: 'Über/Unter',
          line: '1',
          lineText: 'Total1',
          set: { mLine: true, lineLeftText: 'TennisTotal', perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'Total1Under',
          Gname: 'Über/Unter',
          lineText: 'TotalOne',
          line: '1',
        },
      ],
    },
    {
      // 3
      all: [
        {
          preText: '1X',
          type: 'Double_1X',
          Gname: 'DoppelteChance',
        },
        {
          preText: '12',
          type: 'Double_12',
          Gname: 'DoppelteChance',
        },
        {
          preText: 'X2',
          type: 'Double_X2',
          Gname: 'DoppelteChance',
        },
      ],
    },
    {
      // 4
      all: [
        {
          preTextT: 'yes_unabrr',
          type: 'Both_Y',
          Gname: 'Treffenbeide?',
        },
        {
          preTextT: 'no_unabrr',
          type: 'Both_N',
          Gname: 'Treffenbeide?',
        },
      ],
    },
    {
      // 5
      all: [
        {
          preText: '1',
          type: 'FirstScore_1',
          Gname: 'NT',
        },
        {
          preText: 'x',
          type: 'FirstScore_None',
          Gname: 'NT',
        },
        {
          preText: '2',
          type: 'FirstScore_2',
          Gname: 'NT',
        },
      ],
    },
    {
      // 6
      all: [
        {
          preText: '1',
          type: 'FirstHalf_1',
          Gname: 'TIPP 1.HZ',
        },
        {
          preText: 'x',
          type: 'FirstHalf_X',
          Gname: 'TIPP 1.HZ',
        },
        {
          preText: '2',
          type: 'FirstHalf_2',
          Gname: 'TIPP 1.HZ',
        },
      ],
      Basketball: [
        {
          preText: '1',
          type: 'BasketFirstHalf_1',
          Gname: 'TIPP 1.HZ',
        },
        {
          preText: 'x',
          type: 'BasketFirstHalf_X',
          Gname: 'TIPP 1.HZ',
        },
        {
          preText: '2',
          type: 'BasketFirstHalf_2',
          Gname: 'TIPP 1.HZ',
        },
      ],
      Tennis: [
        {
          preText: '1',
          type: 'TennisFirstSet_1',
          Gname: 'TIPP 1.HZ',
        },
        {
          preText: '2',
          type: 'TennisFirstSet_2',
          Gname: 'TIPP 1.HZ',
        },
      ],
    },
    {
      // 7
      all: [
        {
          preTextT: 'Over_abrr',
          type: 'FirstHalfTotalsO_0_5',
          Gname: 'Ü/U 1.HZ',
          line: '1',
          lineText: 'FirstHalfTotalsO_0_5',
          set: { mLine: true, perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'FirstHalfTotalsU_0_5',
          line: '1',
          Gname: 'Ü/U 1.HZ',
        },
        {
          preTextT: 'Over_abrr',
          type: 'FirstHalfTotalsO_1_5',
          line: '2',
          lineText: 'FirstHalfTotalsO_1_5',
          Gname: 'Ü/U 1.HZ',
        },
        {
          preTextT: 'Under_abrr',
          type: 'FirstHalfTotalsU_1_5',
          line: '2',
          Gname: 'Ü/U 1.HZ',
        },
      ],
    },
    {
      // 8
      all: [
        {
          preText: '1',
          type: 'FirstScore_1',
          Gname: 'NT',
        },
        {
          preText: 'x',
          type: 'FirstScore_None',
          Gname: 'NT',
        },
        {
          preText: '2',
          type: 'FirstScore_2',
          Gname: 'NT',
        },
      ],
      Soccer: [
        {
          preText: '1',
          type: 'FirstScore_1',
          Gname: 'NT',
          specialIsActive: false,
        },
        {
          preText: 'x',
          type: 'FirstScore_None',
          Gname: 'NT',
          specialIsActive: false,
        },
        {
          preText: '2',
          type: 'FirstScore_2',
          Gname: 'NT',
          specialIsActive: false,
        },
      ],
    },
    {
      // 9
      all: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'rThreeWay',
          Notes: 'no diff on sports type',
          lineText: 'Totals_O1_5',
        },
        {
          preText: 'x',
          type: 'RestThreeWayX',
          Gname: 'rThreeWay',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'rThreeWay',
        },
      ],
      Soccer: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'rThreeWay',
          Notes: 'no diff on sports type',
          lineText: 'Totals_O1_5',
          specialIsActive: false,
        },
        {
          preText: 'x',
          type: 'RestThreeWayX',
          Gname: 'rThreeWay',
          specialIsActive: false,
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'rThreeWay',
          specialIsActive: false,
        },
      ],
      'Motor sport': [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      'Ice Hockey': [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: 'x',
          type: 'RestThreeWayX',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],

      'Field Hockey': [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: 'x',
          type: 'RestThreeWayX',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      Tennis: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      Basketball: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      'Table tennis': [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      Volleyball: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      Darts: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      Snooker: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      Baseball: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      'Cross-Country': [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      Curling: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      Biathlon: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      'Short Track Speed Skating': [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
    },
    {
      // 10
      all: [
        {
          preTextT: 'Over_abrr',
          type: 'TotalOneOver',
          Gname: 'Über/Unter',
          line: '1',
          lineText: 'TotalOne',
          set: { mLine: true, perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'TotalOneUnder',
          Gname: 'Über/Unter',
          lineText: 'TotalOne',
          line: '1',
        },
        {
          preTextT: 'Over_abrr',
          type: 'TotalTwoOver',
          Gname: 'Über/Unter',
          lineText: 'TotalTwo',
          line: '2',
          set: { mLine: true, perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'TotalTwoUnder',
          Gname: 'Über/Unter',
          lineText: 'TotalTwo',
          line: '2',
        },

        {
          preTextT: 'Over_abrr',
          type: 'TotalThreeOver',
          Gname: 'Über/Unter',
          lineText: 'TotalThree',
          line: '3',
          set: { mLine: true, perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'TotalThreeUnder',
          Gname: 'Über/Unter',
          lineText: 'TotalThree',
          line: '3',
        },
        {
          preTextT: 'Over_abrr',
          type: 'TotalFourOver',
          Gname: 'Über/Unter',
          lineText: 'TotalFour',
          line: '4',
          set: { mLine: true, perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'TotalFourUnder',
          Gname: 'Über/Unter',
          lineText: 'TotalFour',
          line: '4',
        },
      ],
      Tennis: [
        {
          preTextT: 'Over_abrr',
          type: 'Total1Over',
          Gname: 'Über/Unter',
          line: '1',
          lineText: 'Total1',
          set: { mLine: true, perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'Total1Under',
          Gname: 'Über/Unter',
          lineText: 'Total1',
          line: '1',
        },
        {
          preTextT: 'Over_abrr',
          type: 'Total2Over',
          Gname: 'Über/Unter',
          lineText: 'Total2',
          line: '2',
        },
        {
          preTextT: 'Under_abrr',
          type: 'Total2Under',
          Gname: 'Über/Unter',
          lineText: 'Total2',
          line: '2',
        },

        {
          preTextT: 'Over_abrr',
          type: 'Total3Over',
          Gname: 'Über/Unter',
          lineText: 'Total3',
          line: '3',
        },
        {
          preTextT: 'Under_abrr',
          type: 'Total3Under',
          Gname: 'Über/Unter',
          lineText: 'Total3',
          line: '3',
        },
      ],
      Basketball: [
        {
          preTextT: 'Over_abrr',
          type: 'Total1Over',
          Gname: 'Over/Under',
          line: '1',
          lineText: 'Total1',
          set: { mLine: true, lineLeftText: 'BasketTotal', perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'Total1Under',
          Gname: 'Over/Under',
          line: '1',
        },
      ],
      Volleyball: [
        {
          preTextT: 'Over_abrr',
          type: 'TennisTotal_O',
          Gname: 'Over/Under',
          line: '1',
          lineText: 'TennisTotal',
          set: { mLine: true, lineLeftText: 'TennisTotal', perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'TennisTotal_U',
          Gname: 'Over/Under',
          line: '1',
        },
      ],
    },
    {
      // 11
      all: [
        {
          preText: '1',
          type: 'FirstHalf_1',
          Gname: '1x2 HT',
        },
        {
          preText: 'x',
          type: 'FirstHalf_X',
          Gname: '1x2 HT',
        },
        {
          preText: '2',
          type: 'FirstHalf_2',
          Gname: '1x2 HT',
        },
      ],
      Tennis: [
        {
          preText: '1',
          type: 'TennisFirstSet1',
          Gname: '1x2 HT',
        },
        {
          preText: '2',
          type: 'TennisFirstSet2',
          Gname: '1x2 HT',
        },
      ],
      Snooker: [
        {
          preText: '1',
          type: 'TennisFirstSet1',
          Gname: '1x2 HT',
        },
        {
          preText: '2',
          type: 'TennisFirstSet2',
          Gname: '1x2 HT',
        },
      ],
    },
    {
      // 12
      all: [
        {
          preText: '1',
          type: 'FirstHalfNG_1',
          Gname: 'NT',
        },
        {
          preText: 'x',
          type: 'FirstHalfNG_X',
          Gname: 'NT',
        },
        {
          preText: '2',
          type: 'FirstHalfNG_2',
          Gname: 'NT',
        },
      ],
      Soccer: [
        {
          preText: '1',
          type: 'FirstHalfNG_1',
          Gname: 'NT_HZ',
          specialIsActive: false,
        },
        {
          preText: 'x',
          type: 'FirstHalfNG_X',
          Gname: 'NT_HZ',
          specialIsActive: false,
        },
        {
          preText: '2',
          type: 'FirstHalfNG_2',
          Gname: 'NT_HZ',
          specialIsActive: false,
        },
      ],
    },
    {
      // 13
      all: [
        {
          preText: '1',
          type: 'FirstHalfRS_1',
          Gname: 'RoM HT',
        },
        {
          preText: 'x',
          type: 'FirstHalfRS_X',
          Gname: 'RoM HT',
        },
        {
          preText: '2',
          type: 'FirstHalfRS_2',
          Gname: 'RoM HT',
        },
      ],
      Soccer: [
        {
          preText: '1',
          type: 'FirstHalfRS_1',
          Gname: 'RoM HT',
          specialIsActive: false,
        },
        {
          preText: 'x',
          type: 'FirstHalfRS_X',
          Gname: 'RoM HT',
          specialIsActive: false,
        },
        {
          preText: '2',
          type: 'FirstHalfRS_2',
          Gname: 'RoM HT',
          specialIsActive: false,
        },
      ],
      Tennis: [
        {
          preText: '1',
          type: 'FirstHalfRS_1',
          Gname: 'RoM HT',
        },
        {
          preText: '2',
          type: 'FirstHalfRS_2',
          Gname: 'RoM HT',
        },
      ],
      Basketball: [
        {
          preText: '1',
          type: 'FirstHalfRS_1',
          Gname: 'RoM HT',
        },
        {
          preText: '2',
          type: 'FirstHalfRS_2',
          Gname: 'RoM HT',
        },
      ],
      'Table tennis': [
        {
          preText: '1',
          type: 'FirstHalfRS_1',
          Gname: 'RoM HT',
        },
        {
          preText: '2',
          type: 'FirstHalfRS_2',
          Gname: 'RoM HT',
        },
      ],
      Volleyball: [
        {
          preText: '1',
          type: 'FirstHalfRS_1',
          Gname: 'RoM HT',
        },
        {
          preText: '2',
          type: 'FirstHalfRS_2',
          Gname: 'RoM HT',
        },
      ],
      Snooker: [
        {
          preText: '1',
          type: 'FirstHalfRS_1',
          Gname: 'RoM HT',
        },
        {
          preText: '2',
          type: 'FirstHalfRS_2',
          Gname: 'RoM HT',
        },
      ],
      'Motor sport': [
        {
          preText: '1',
          type: 'FirstHalfRS_1',
          Gname: 'RoM HT',
        },
        {
          preText: '2',
          type: 'FirstHalfRS_2',
          Gname: 'RoM HT',
        },
      ],
      Baseball: [
        {
          preText: '1',
          type: 'FirstHalfRS_1',
          Gname: 'RoM HT',
        },
        {
          preText: '2',
          type: 'FirstHalfRS_2',
          Gname: 'RoM HT',
        },
      ],
      'Cross-Country': [
        {
          preText: '1',
          type: 'FirstHalfRS_1',
          Gname: 'RoM HT',
        },
        {
          preText: '2',
          type: 'FirstHalfRS_2',
          Gname: 'RoM HT',
        },
      ],
      Curling: [
        {
          preText: '1',
          type: 'FirstHalfRS_1',
          Gname: 'RoM HT',
        },
        {
          preText: '2',
          type: 'FirstHalfRS_2',
          Gname: 'RoM HT',
        },
      ],
      Biathlon: [
        {
          preText: '1',
          type: 'FirstHalfRS_1',
          Gname: 'RoM HT',
        },
        {
          preText: '2',
          type: 'FirstHalfRS_2',
          Gname: 'RoM HT',
        },
      ],
      'Short Track Speed Skating': [
        {
          preText: '1',
          type: 'FirstHalfRS_1',
          Gname: 'RoM HT',
        },
        {
          preText: '2',
          type: 'FirstHalfRS_2',
          Gname: 'RoM HT',
        },
      ],
    },
    {
      // 14
      all: [
        {
          preTextT: 'Over_abrr',
          type: 'HalfTotal1Over',
          Gname: 'Ü/U 1.HZ',
          line: '1',
          lineText: 'HalfTotal1',
          set: { mLine: true, perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'HalfTotal1Under',
          line: '1',
          lineText: 'HalfTotal1',
          Gname: 'Ü/U 1.HZ',
        },
        {
          preTextT: 'Over_abrr',
          type: 'HalfTotal2Over',
          line: '2',
          lineText: 'HalfTotal2',
          Gname: 'Ü/U 1.HZ',
        },
        {
          preTextT: 'Under_abrr',
          type: 'HalfTotal2Under',
          line: '2',
          lineText: 'HalfTotal2',
          Gname: 'Ü/U 1.HZ',
        },
        {
          preTextT: 'Over_abrr',
          type: 'HalfTotal3Over',
          line: '3',
          lineText: 'HalfTotal3',
          Gname: 'Ü/U 1.HZ',
        },
        {
          preTextT: 'Under_abrr',
          type: 'HalfTotal3Under',
          line: '3',
          lineText: 'HalfTotal3',
          Gname: 'Ü/U 1.HZ',
        },
      ],
    },
    {
      // 15
      all: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: 'x',
          type: 'RestThreeWayX',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      Tennis: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      Basketball: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      Darts: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      'Table tennis': [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      Volleyball: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      Snooker: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      Baseball: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      'Cross-Country': [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      Curling: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      Biathlon: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      'Short Track Speed Skating': [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
    },
    {
      // 16
      all: [
        {
          preTextT: 'Over_abrr',
          type: 'Total2Over',
          Gname: 'HomeTotal_Short',
          line: '1',
          lineText: 'Total2',
          set: { mLine: true, perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'Total2Under',
          Gname: 'HomeTotal_Short',
          line: '1',
          lineText: 'Total2',
        },
      ],
    },
    {
      // 17
      all: [
        {
          preTextT: 'Over_abrr',
          type: 'Total3Over',
          Gname: 'AwayTotal_Short',
          line: '1',
          lineText: 'Total3',
          set: { mLine: true, perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'Total3Under',
          Gname: 'AwayTotal_Short',
          line: '1',
          lineText: 'Total3',
        },
      ],
    },
    {
      // 18 => Tennis Set ( Live ) , Volleyball Set
      all: [
        {
          preText: '1',
          type: 'TennisFirstSet1',
          Gname: 'TennisSet_Long',
        },
        {
          preText: '2',
          type: 'TennisFirstSet2', // DB deki isim
          Gname: 'TennisSet_Long', // Translate ve live.component teki karşılığı
        },
      ],
      Tennis: [
        {
          preText: '1',
          type: 'TennisFirstSet1',
          Gname: 'TennisSet_Long',
          specialIsActive: false,
        },
        {
          preText: '2',
          type: 'TennisFirstSet2', // DB deki isim
          Gname: 'TennisSet_Long', // Translate ve live.component teki karşılığı
          specialIsActive: false,
        },
      ],
      Volleyball: [
        {
          preText: '1',
          type: 'TennisFirstSet1',
          Gname: 'TennisSet_Long',
          specialIsActive: false,
        },
        {
          preText: '2',
          type: 'TennisFirstSet2', // DB deki isim
          Gname: 'TennisSet_Long', // Translate ve live.component teki karşılığı
          specialIsActive: false,
        },
      ],
      'Table tennis': [
        {
          preText: '1',
          type: 'TennisFirstSet1',
          Gname: 'TennisSet_Long',
          specialIsActive: false,
        },
        {
          preText: '2',
          type: 'TennisFirstSet2', // DB deki isim
          Gname: 'TennisSet_Long', // Translate ve live.component teki karşılığı
          specialIsActive: false,
        },
      ],
    },
    {
      // 19 => IceHockey Period ( Live )
      all: [
        {
          preText: '1',
          type: 'FirstHalfNG_1',
          Gname: 'IceHockeyPeriod_Short',
        },
        {
          preText: 'x',
          type: 'FirstHalfNG_X',
          Gname: 'IceHockeyPeriod_Short',
        },
        {
          preText: '2',
          type: 'FirstHalfNG_2',
          Gname: 'IceHockeyPeriod_Short',
        },
      ],
    },
    {
      // 20 => Tennis Total Sets ( Live )
      all: [
        {
          preTextT: 'O',
          type: 'HalfTotal2Over',
          line: '1',
          lineText: 'HalfTotal2',
          Gname: 'TennisTotalSet_Short',
          set: { mLine: true, perLine: 2 },
        },
        {
          preTextT: 'U',
          type: 'HalfTotal2Under', // DB deki isim
          Gname: 'TennisTotalSet_Short', // Translate ve live.component teki karşılığı
          line: '1',
          lineText: 'HalfTotal2',
        },
      ],
    },
    {
      // 21 => Tennis Total Set ( Live )
      all: [
        {
          preText: 'O',
          type: 'FirstHalf_1',
          Gname: 'TennisTotalSet_Long',
        },
        {
          preText: 'U',
          type: 'FirstHalf_2',
          Gname: 'TennisTotalSet_Long',
        },
      ],
    },

    {
      // 22
      all: [
        {
          preText: '1',
          type: 'HandicapOneHome',
          Gname: 'Handicap',
          line: '1',
          lineText: 'HandicapOne',
          set: { mLine: true, perLine: 3 },
        },
        {
          preText: 'X',
          type: 'HandicapOneDraw',
          Gname: 'Handicap',
          line: '1',
        },
        {
          preText: '2',
          type: 'HandicapOneAway',
          Gname: 'Handicap',
          line: '1',
        },
        {
          preText: '1',
          type: 'HandicapTwoHome',
          Gname: 'Handicap',
          line: '1',
          lineText: 'HandicapTwo',
        },
        {
          preText: 'X',
          type: 'HandicapTwoDraw',
          Gname: 'Handicap',
          line: '1',
        },
        {
          preText: '2',
          type: 'HandicapTwoAway',
          Gname: 'Handicap',
          line: '1',
        },
        {
          preText: '1',
          type: 'HandicapThreeHome',
          Gname: 'Handicap',
          line: '1',
          lineText: 'HandicapThree',
        },
        {
          preText: 'X',
          type: 'HandicapThreeDraw',
          Gname: 'Handicap',
          line: '1',
        },
        {
          preText: '2',
          type: 'HandicapThreeAway',
          Gname: 'Handicap',
          line: '1',
        },
      ],
    },
    {
      // 23
      all: [
        {
          preText: '1X',
          type: 'Double1X',
          Gname: 'DoppelteChance',
        },
        {
          preText: '12',
          type: 'Double12',
          Gname: 'DoppelteChance',
        },
        {
          preText: 'X2',
          type: 'DoubleX2',
          Gname: 'DoppelteChance',
        },
      ],
    },
    {
      // 24
      all: [
        {
          preTextT: 'yes_unabrr',
          type: 'Both_Y',
          Gname: 'Treffenbeide?',
        },
        {
          preTextT: 'no_unabrr',
          type: 'Both_N',
          Gname: 'Treffenbeide?',
        },
      ],
    },
    {
      // 25, only first ou
      all: [
        {
          preTextT: 'Over_abrr',
          type: 'TotalSpread_O',
          Gname: 'Over/Under',
          line: '1',
          lineText: 'BasketTotal',
          set: { mLine: true, lineLeftText: 'BasketTotal', perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'TotalSpread_U',
          Gname: 'Over/Under',
          line: '1',
        },
      ],
      Basketball: [
        {
          preTextT: 'Over_abrr',
          type: 'Total1Over',
          Gname: 'Over/Under',
          line: '1',
          lineText: 'BasketTotal',
          set: { mLine: true, lineLeftText: 'BasketTotal', perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'Total1Under',
          Gname: 'Over/Under',
          line: '1',
        },
      ],
    },
    {
      // 26, only first ou
      all: [
        {
          preText: '1',
          type: 'HandicapOneHome',
          Gname: 'Handicap',
          line: '1',
          lineText: 'HandicapOne',
          set: { mLine: true, perLine: 2 },
        },

        {
          preText: '2',
          type: 'HandicapOneAway',
          Gname: 'Handicap',
          line: '1',
        },
      ],
    },
    {
      // 27 ng 1ht
      all: [
        {
          preText: '1',
          type: 'FirstHalfNG_1',
          Gname: 'NT',
        },
        {
          preText: 'x',
          type: 'FirstHalfNG_X',
          Gname: 'NT',
        },
        {
          preText: '2',
          type: 'FirstHalfNG_2',
          Gname: 'NT',
        },
      ],
      Soccer: [
        {
          preText: '1',
          type: 'FirstHalfFirstScore_1',
          Gname: 'NT_HZ',
          specialIsActive: false,
        },
        {
          preText: 'x',
          type: 'FirstHalfFirstScore_None',
          Gname: 'NT_HZ',
          specialIsActive: false,
        },
        {
          preText: '2',
          type: 'FirstHalfFirstScore_2',
          Gname: 'NT_HZ',
          specialIsActive: false,
        },
      ],
    },
  ];

  _GroupByEventName = new GroupByEventName();

  constructor(private domSanitizer: DomSanitizer) {
    this.leftMenuSportDayFilter = 300;
    if (this.favList.length === 0) {
      const storageFavList = localStorage.getItem('favList');
      const storageFavListJson = storageFavList ? JSON.parse(storageFavList) : [];
      if (Array.isArray(storageFavListJson) && storageFavListJson.length > 0) {
        this.favList = storageFavListJson;
        this.favListListener.emit();
      }
    }
  }

  setLeagueData(v: Array<any>) {
    // console.log('DATA--HELPER--setLeagueData',v);
    this.LeagueData = v;
    this.LeagueDataListener.emit(this.LeagueData);
  }
  setLiveData(v: Array<any>) {
    this.liveData = v;
    this.liveDataListener.emit(v);
  }
  setLiveEventRebuilded(e) {
    this.liveEventDataRebuilded = e;
    this.liveEventDataRebuildedListener.emit(this.liveEventDataRebuilded);
  }

  setLiveFilterItems(e) {
    this.liveFilterItems = e;
    this.liveFilterItemsListener.emit(this.liveFilterItems);
  }

  setLiveFavoriteTournamentData(e) {
    this.liveFavoriteTournamentList = e;
    localStorage.setItem('storage-live-favorite-tournamen-list', JSON.stringify(e));
  }

  getLiveFavoriteTournamentData(): Array<number> {
    this.liveFavoriteTournamentList = JSON.parse(localStorage.getItem('storage-live-favorite-tournamen-list'));
    if (this.liveFavoriteTournamentList == null) {
      this.liveFavoriteTournamentList = [];
    }
    return this.liveFavoriteTournamentList;
  }

  setFavoritesButtonStatus(status) {
    this.liveFavoriteButtonStatus = status;
    localStorage.setItem('storage-live-favorite-button', JSON.stringify(status));
    this.liveFavouriteStateChanged.emit();
  }

  getFavoritesButtonStatus() {
    const bStaus = localStorage.getItem('storage-live-favorite-button');

    if (bStaus == '' || bStaus == null) {
      localStorage.setItem('storage-live-favorite-button', JSON.stringify(false));
      this.liveFavoriteButtonStatus = false;
    } else {
      this.liveFavoriteButtonStatus = JSON.parse(bStaus);
    }
    return this.liveFavoriteButtonStatus;
  }

  getStorageBookBets() {
    const storageBookBets = localStorage.getItem('bookBetsReserve');
    const storageBookBetsJson = JSON.parse(storageBookBets);
    if (Array.isArray(storageBookBetsJson) && storageBookBetsJson.length > 0) {
      const a = storageBookBetsJson.filter(slipItem => new Date(slipItem.id).getDay() === new Date().getDay());
      localStorage.setItem('bookBetsReserve', JSON.stringify(a));
      this.bookBetsReserveList = a;
    } else {
      this.bookBetsReserveList = [];
    }
  }

  setStorageBookBets(bookBetsItem: any) {
    const rebuildBookBetsItem = {
      ...bookBetsItem,
      id: new Date().getTime(),
    };
    const storageBookBets = this.bookBetsReserveList ? [rebuildBookBetsItem, ...this.bookBetsReserveList] : [rebuildBookBetsItem];
    localStorage.setItem('bookBetsReserve', JSON.stringify(storageBookBets));
    this.getStorageBookBets();
  }

  deleteStorageBookBets({ bookBetsItem, deleteType = 'item' }: { bookBetsItem: any; deleteType?: string }) {
    if (deleteType === 'item') {
      const storageBookBets = [...this.bookBetsReserveList];
      const deletedBookBets = storageBookBets.filter((i: any) => i?.id !== bookBetsItem?.id);
      localStorage.setItem('bookBetsReserve', JSON.stringify(deletedBookBets));
    } else if (deleteType === 'all') {
      localStorage.setItem('bookBetsReserve', JSON.stringify([]));
    }

    this.getStorageBookBets();
  }

  webWorkerLiveJob = wwsConfig => {
    try {
      const all_lang = {
        en: 'All',
        tr: 'Hepsi',
        ar: 'الكل',
        de: 'Alle',
        es: 'Todo',
        fa: 'همه',
        ku: 'هه موو',
        vi: 'Tất cả',
        fr: 'Tous',
        hr: 'undefined',
        sq: 'undefined',
        cs: 'undefined',
        sk: 'undefined',
        ru: 'Все',
        pl: 'Wszystko',
        el: 'Όλα',
        bg: 'Всички',
        da: 'Alle',
        sr: 'Sve',
        pr: 'Tudo',
        ro: 'Toate',
        al: 'Të gjitha',
      };
      const selectedSportName = wwsConfig.mfbysk === '' ? all_lang[wwsConfig.langCode] : wwsConfig.mfbysk;
      const isAll = Object.values(all_lang).includes(selectedSportName);
      const oddTypes = [
        ['OddValue1', 'OddValue2', 'OddValue3'],
        ['OddValueFirstScore_1', 'OddValueFirstScore_None', 'OddValueFirstScore_2'],
        ['RestThreeWay1', 'RestThreeWayX', 'RestThreeWay2'],
        ['Total1OverOddValue', 'Total1UnderOddValue', 'Total2OverOddValue', 'Total2UnderOddValue', 'Total3OverOddValue', 'Total3UnderOddValue'],
        ['OddValueFirstHalf_1', 'OddValueFirstHalf_X', 'OddValueFirstHalf_2', 'OddValueTennisFirstSet1', 'OddValueTennisFirstSet2', 'Total3UnderOddValue'],
        ['OddValueFirstHalfNG_1', 'OddValueFirstHalfNG_X', 'OddValueFirstHalfNG_2'],
        ['OddValueFirstHalfRS_1', 'OddValueFirstHalfRS_X', 'OddValueFirstHalfRS_2'],
        ['HalfTotal1OverOddValue', 'HalfTotal1UnderOddValue', 'HalfTotal2OverOddValue', 'HalfTotal2UnderOddValue', 'HalfTotal3OverOddValue', 'HalfTotal3UnderOddValue'],
        ['OddValueFirstScore_1', 'OddValueFirstScore_None', 'OddValueFirstScore_2'],
        ['OddValueRestThreeWay1', 'OddValueRestThreeWayX', 'OddValueRestThreeWay2'],
        ['OddValueTotal1Over', 'OddValueTotal1Under', 'OddValueTotal2Over', 'OddValueTotal2Under', 'OddValueTotal3Over', 'OddValueTotal3Under'],
        ['OddValueFirstHalf_1', 'OddValueFirstHalf_X', 'OddValueFirstHalf_2', 'OddValueTennisFirstSet1', 'OddValueTennisFirstSet2'],
        ['OddValueFirstHalfNG_1', 'OddValueFirstHalfNG_X', 'OddValueFirstHalfNG_2'],
        ['OddValueFirstHalfRS_1', 'OddValueFirstHalfRS_X', 'OddValueFirstHalfRS_2'],
        ['OddValueHalfTotal1Over', 'OddValueHalfTotal1Under', 'OddValueHalfTotal2Over', 'OddValueHalfTotal2Under', 'OddValueHalfTotal3Over', 'OddValueHalfTotal3Under'],
      ];

      let live = [...wwsConfig.lml.filter(i => i.HasStreaming === 'live')];
      let upcoming = [...wwsConfig.lml.filter(i => i.HasStreaming === 'pre')];

      const sportsGroupRebuildData = (data: any) => {
        // sporlara göre gruplar
        const a = {};
        if (data.length > 0) {
          data.forEach(i => {
            if (i.SportName) {
              if (a[i.SportName]) {
                a[i.SportName] = [...a[i.SportName], i];
              } else {
                a[i.SportName] = [i];
              }
            }
          });
        }

        return a;
      };

      const matchTimeControl = matchData => {
        const timeStatu = matchData?.TimeStatu;
        let matchTime = 0;
        if (matchData?.SportId === 1) {
          if (Object.values(timeStatusList).some(i => i.timeStatu === timeStatu)) {
            matchTime = timeStatusList[timeStatu].time;
          } else if (!isNaN(Number(matchTime))) {
            matchTime = matchData?.MatchTime;
          }
        } else {
          matchTime = Number(`${timeStatu}.${isNaN(matchData?.MatchTime) ? 0 : matchData?.MatchTime}`);
        }

        return matchTime;
      };

      const matchTimeControlUpComing = matchData => {
        const timeStatu = new Date(matchData?.MatchDate).getTime();

        return timeStatu;
      };

      const timeStatusList = {
        3: {
          timeStatu: 3,
          time: 45,
        },
        6: {
          timeStatu: 6,
          time: 90,
        },
        9: {
          timeStatu: 9,
          time: 105,
        },
        11: {
          timeStatu: 11,
          time: 120,
        },
        12: {
          timeStatu: 12,
          time: 120,
        },
        13: {
          timeStatu: 13,
          time: 120,
        },
      };

      const sortBetRadarIdFixture = (data: any) => {
        data.sort((a, b) => {
          const betRadarIdA = a?.BetradarMatchId;
          const betRadarIdB = b?.BetradarMatchId;

          if (betRadarIdA === betRadarIdB) {
            // Eğer zamanlar eşitse alfabetik sıralama yap
            const eventNameA = a.HomeTeam || '';
            const eventNameB = b.HomeTeam || '';
            return eventNameA.localeCompare(eventNameB);
          } else {
            return betRadarIdB - betRadarIdA; // Büyük olanı başa al
          }
        });

        return data;
      };

      const sortTimeFixture = (data: any) => {
        data.sort((a, b) => {
          const timeA = matchTimeControl(a);
          const timeB = matchTimeControl(b);

          if (timeA === timeB) {
            // Eğer zamanlar eşitse alfabetik sıralama yap
            const eventNameA = a.HomeTeam || '';
            const eventNameB = b.HomeTeam || '';
            return eventNameA.localeCompare(eventNameB);
          } else {
            return timeB - timeA; // Büyük olanı başa al
          }
        });

        return data;
      };

      const sortTimeFixtureUpComing = (data: any) => {
        data.sort((a, b) => {
          const timeA = matchTimeControlUpComing(a);
          const timeB = matchTimeControlUpComing(b);

          if (timeA === timeB) {
            // Eğer zamanlar eşitse alfabetik sıralama yap
            const eventNameA = a.HomeTeam || '';
            const eventNameB = b.HomeTeam || '';
            return eventNameA.localeCompare(eventNameB);
          } else {
            return timeA - timeB; // Büyük olanı başa al
          }
        });

        return data;
      };

      const tournamentRebuild = (data, sortKey, matchStatus) => {
        const a = {};
        let b = [];
        data.forEach(i => {
          if (i[sortKey]) {
            if (a[`${i[sortKey]}-${i.TournamentId}`]) {
              a[`${i[sortKey]}-${i.TournamentId}`] = [...a[`${i[sortKey]}-${i.TournamentId}`], i];
            } else {
              a[`${i[sortKey]}-${i.TournamentId}`] = [i];
            }
          }
        });

        const sortedArray = Object.entries(a).sort((x, y) => Number(x[0].split('-')[0]) - Number(y[0].split('-')[0]));

        const sortedObj = {};
        for (let i = 0; i < sortedArray.length; i++) {
          sortedObj[sortedArray[i][0]] = sortedArray[i][1];
        }

        Object.values(sortedObj).forEach(x => {
          if (Array.isArray(x) && x.length > 0) {
            const matchItem = x[0];
            b = [
              ...b,
              {
                type: 'TournamentName',
                TournamentName: matchItem.CategoryName + '/' + matchItem.TournamentName,
                SportNameOriginal: matchItem.SportNameOriginal,
                TournamentNameShort: matchItem.TournamentName,
                SportName: matchItem.SportName + '/' + matchItem.CategoryName,
                TournamentId: matchItem.TournamentId,
                IsoName: matchItem.IsoName,
                BetradarMatchId: matchItem.TournamentId,
              },
              ...(matchStatus === 'pre' ? sortTimeFixtureUpComing(x) : sortBetRadarIdFixture(x)),
            ];
          }
        });

        return b;
      };
      const liveRebuildData = (data: any) => {
        const result = {};
        if (data && Object.values(data).length > 0) {
          Object.keys(data).forEach(key => {
            const sportName = data[key]?.[0]?.SportName;
            const sportId = data[key]?.[0]?.SportId;
            let sportsData = [];
            if (Array.isArray(data[key]) && data[key].length > 0) {
              sportsData = data[key].map(MatchItem => {
                const rebuildMatchItem = { ...MatchItem };
                const oldMatchItem = wwsConfig.old_lml.find(s => s.EventId === MatchItem.EventId);

                wwsConfig.oddtype.forEach(oddType => {
                  oddTypes[oddType].forEach(z => {
                    if (oldMatchItem && oldMatchItem[z] > rebuildMatchItem[z]) {
                      rebuildMatchItem[z + 'css'] = 'downarrow';
                    }
                    if (oldMatchItem && oldMatchItem[z] < rebuildMatchItem[z]) {
                      rebuildMatchItem[z + 'css'] = 'uparrow';
                    }
                  });
                });

                return { ...rebuildMatchItem, type: 'Match' };
              });
              if (wwsConfig?.sortType === 'time') {
                sportsData = [
                  {
                    type: 'liveHeader',
                    sportName: sportName,
                    sportId: sportId,
                    isAll: isAll,
                    liveCount: sportsData.length,
                  },
                  ...sortTimeFixture(sportsData),
                ];
              } else {
                sportsData = [
                  {
                    type: 'liveHeader',
                    sportName: sportName,
                    sportId: sportId,
                    isAll: isAll,
                    liveCount: sportsData.length,
                  },
                  ...tournamentRebuild(sportsData, 'Rank', 'live'),
                ];
              }
            }

            result[key] = sportsData;
          });

          const sortedArray = Object.entries(result).sort((x, y) => {
            const a = x?.[1]?.[0]?.sportId || 0;
            const b = y?.[1]?.[0]?.sportId || 0;
            return Number(b) - Number(a);
          });
          const sortedObj = {};
          for (let i = 0; i < sortedArray.length; i++) {
            sortedObj[sortedArray[i][0]] = sortedArray[i][1];
          }

          return sortedObj;
        }
      };

      const upcomingRebuildData = (data: any) => {
        const result = {};
        if (data && Object.values(data).length > 0) {
          Object.keys(data).forEach(key => {
            const sportName = data[key]?.[0]?.SportName;
            const sportId = data[key]?.[0]?.SportId;
            let sportsData = [];
            if (Array.isArray(data[key]) && data[key].length > 0) {
              sportsData = data[key].map(MatchItem => {
                const rebuildMatchItem = { ...MatchItem };
                return { ...rebuildMatchItem, type: 'Match' };
              });

              if (wwsConfig?.sortType === 'time') {
                sportsData = [
                  {
                    type: 'upComingHeader',
                    sportName: sportName,
                    sportId: sportId,
                    isAll: isAll,
                    upComingCount: sportsData.length,
                  },
                  ...sortTimeFixtureUpComing(sportsData),
                ];
              } else {
                sportsData = [
                  {
                    type: 'upComingHeader',
                    sportName: sportName,
                    sportId: sportId,
                    isAll: isAll,
                    upComingCount: sportsData.length,
                  },
                  ...tournamentRebuild(sportsData, 'SequenceNumber', 'pre'),
                ];
              }
            }

            result[key] = sportsData;
          });

          const sortedArray = Object.entries(result).sort((x, y) => {
            const a = x?.[1]?.[0]?.sportId || 0;
            const b = y?.[1]?.[0]?.sportId || 0;
            return Number(b) - Number(a);
          });

          const sortedObj = {};
          for (let i = 0; i < sortedArray.length; i++) {
            sortedObj[sortedArray[i][0]] = sortedArray[i][1];
          }

          return sortedObj;
        }
      };

      if (live.length > 0) {
        if (wwsConfig.isMySlipEnvironment && wwsConfig.isMySlipButton) {
          live = live.filter(x => wwsConfig.mySlipMatchList.includes(x.BetradarMatchId));
        }
        if (wwsConfig.isLiveStreamEnvironment && wwsConfig.isOnTvButton) {
          live = live.filter(x => wwsConfig.liveTvList.some(i => i.matchId === x.BetradarMatchId));
        }

        let liveSportsGroup = sportsGroupRebuildData(live);
        if (!(wwsConfig.isMySlipButton || wwsConfig.isOnTvButton)) {
          if (!isAll) {
            liveSportsGroup = {
              [selectedSportName]: liveSportsGroup[selectedSportName],
            };
          }
        }

        const liveResult: any[][] = Object.values(liveRebuildData(liveSportsGroup));
        if (liveResult.length > 0) {
          live = liveResult.reduce((val, arr) => {
            return [...arr, ...val];
          }, []);
          if (live.length === 0) {
            live = [
              {
                type: 'liveHeader',
                sportName: selectedSportName,
                isAll: isAll,
                liveCount: 0,
              },
              {
                type: 'liveNotFound',
              },
            ];
          }
        } else {
          live = [
            {
              type: 'liveNotFound',
            },
          ];
        }
      } else {
        live = [
          {
            type: 'liveNotFound',
          },
        ];
      }

      if (upcoming.length > 0) {
        let upcomingSportsGroup = sportsGroupRebuildData(upcoming);
        if (!(wwsConfig.isMySlipButton || wwsConfig.isOnTvButton)) {
          if (!isAll) {
            upcomingSportsGroup = {
              [selectedSportName]: upcomingSportsGroup[selectedSportName],
            };
          }

          const upComingResult: any[][] = Object.values(upcomingRebuildData(upcomingSportsGroup));
          if (upComingResult.length > 0) {
            upcoming = upComingResult.reduce((val, arr) => {
              return [...arr, ...val];
            }, []);
          }
        } else {
          upcoming = [];
        }
      }

      return { dt: [...live, ...upcoming], time: wwsConfig.time };
    } catch (e) {
      console.error(e);
    }
  };

  setLiveEventDetailsData(v: Array<any>) {
    this.liveEventDetailData = v;
    this.liveEventDetailListener.emit(this.liveEventDetailData);
  }

  setLeftMenuSportData(v: Array<any>, dayFilter) {
    this.leftMenuSportData = v;
    this.leftMenuSportDataListener.emit(this.leftMenuSportData);
    this.leftMenuSportDayFilter = dayFilter;
  }

  setSearchData(v) {
    // console.log('--setSearchData--',v);
    this.searchData = v;
    this.searchDataListener.emit(this.searchData);
  }

  setSearchDataViaUrl(v) {
    // console.log('--setSearchDataViaUrl--',v);
    this.searchData = v;
    this.searchDataUrlListener.emit(v);
  }

  setCurrentSlipData(v) {
    // console.log('setCurrentSlipData, ', v);
    this.currentSlipData = [...v];

    // Only send market if setted true in environments.
    if (environment.isActiveBRSmallWidget === true) {
      try {
        if (typeof betaluxBr !== 'undefined' && betaluxBr.isActive('betrecommend')) {
          betaluxBr.get('betrecommend').setMarkets(this.currentSlipData.map(x => parseInt(x.OddId1)).sort());
        }
      } catch (e) {
        console.error(e);
      }
    }

    this.currentSlipDataListener.emit(this.currentSlipData);
    this.numberOfBetsListener.emit(this.currentSlipData.length);
    this.numberOfBets = this.currentSlipData.length;

    const transformedData = this._GroupByEventName.transform(this.currentSlipData.reverse(), null);
    transformedData.find(element => (this.currentSlipInfo.isMultiWaySystem = element.eEvents && element.eEvents.length > 1));
  }

  setTaxRate(v) {
    this.taxRate = v;
    //// console.log('TAX_RATE', this.taxRate);
  }

  setCashoutData(v) {
    if (!v) {
      return;
    }

    this.cashoutData = v;
    this.cashoutDataListener.emit(this.cashoutData);
    this.numberOfCashoutListener.emit(this.cashoutData.length);
    this.numberOfCashout = this.cashoutData.length;
    this.cashoutSlipsList = v.map(newCashoutItem => {
      const _cashoutOldItem = this.cashoutSlipsList.find(y => y.SlipId === newCashoutItem.SlipId);
      if (_cashoutOldItem) {
        // Merge two datas.
        // Old data can contain cashout value.

        newCashoutItem = {
          ..._cashoutOldItem,
          ...newCashoutItem, // new one replaces old one.

          // Below fields are not in CashOutSlipsExternal data.
          CashoutValue: _cashoutOldItem.CashoutValue,
          CashoutSlipDetails: _cashoutOldItem.CashoutSlipDetails,
          State: _cashoutOldItem.State,
          isLive: _cashoutOldItem.isLive,
          details: _cashoutOldItem.details,
        };
      }
      return newCashoutItem;
    });
  }
  setHomeSliderData(e) {
    this.homeSliderData = e;
    this.homeSliderDataListener.emit(this.homeSliderData);
  }
  freebetBonusCheckBox = false;
  boostBonusCheckBox = false;

  setFreeBet(isChecked: any) {
    if (isChecked) {
      this.currentSlipInfo.currentslip_totalStake = this.customerFreeBetBonusInfo.BonusAmount;

      // Checkbox işaretlendiğinde yapılacak işlemler
    } else {
      this.setBetAmounts();
    }
  }
  setCurrentSlipAmount(data) {
    this.currentSlipAmount = data;
    this.currentSlipAmountListener.emit(this.currentSlipAmount);
  }

  setCurrentSlipSystemInfo(data) {
    this.currentSlipSystemSelection = this.currentSlipSystemSelection.filter(item => data.filter(i => `${i.index + 1}_${i.combination}` === item).length > 0);
    this.currentSlipSystemInfo = data;
    if (data.filter(i => i.selection).length > 0) {
      this.currentSlipInfo.isCheckIsSystem = true;
    } else {
      this.currentSlipInfo.isCheckIsSystem = false;
    }

    if (!Array.isArray(this.currentSlipVorabTicket) || this.currentSlipVorabTicket.length === 0 || !this.currentSlipVorabTicket[0]?.SlipType) {
      this.currentSlipSystemInfoListener.emit(this.currentSlipSystemInfo);

      return;
    }

    if (typeof this.currentSlipVorabTicket[0].SlipType === 'string') {
      const slipTypeArray = this.currentSlipVorabTicket[0]?.SlipType.split(',').filter(slipType => slipType.trim() !== '');

      // Eğer slipTypeArray boş ise veya sadece boş stringler içeriyorsa
      if (slipTypeArray.length === 0) {
        this.currentSlipSystemInfoListener.emit(this.currentSlipSystemInfo);

        return;
      }

      // currentSlipSystemInfo array'inin varlığı ve içeriğini kontrol et
      if (!this.currentSlipSystemInfo || this.currentSlipSystemInfo.length === 0) {
        this.currentSlipSystemInfoListener.emit(this.currentSlipSystemInfo);

        return;
      }

      const currentSlipSystemSelectionSet = new Set(this.currentSlipSystemSelection);

      slipTypeArray.forEach(slipType => {
        this.currentSlipSystemInfo.forEach(info => {
          const infoIndexPlusOne = info.index + 1;
          if (slipType === infoIndexPlusOne.toString()) {
            const systemSelectKey = `${infoIndexPlusOne}_${info.combination}`;
            currentSlipSystemSelectionSet.add(systemSelectKey);
            this.currentSlipInfo.isCheckIsSystem = true;
          }
        });
      });

      this.currentSlipSystemSelection = Array.from(currentSlipSystemSelectionSet);
      this.currentSlipSystemInfoListener.emit(this.currentSlipSystemInfo);
    }
  }
  seonResult;
  getSeon(session_id): Promise<string> {
    return new Promise((resolve, reject) => {
      seon.config({
        host: environment.siteUrl,
        session_id: session_id,
        audio_fingerprint: true,
        canvas_fingerprint: true,
        webgl_fingerprint: true,
        max_proxy_delay: 1000,
      });
      seon.getBase64Session(data => {
        if (data) {
          resolve(data); // Asenkron cevabı resolve ile döndür.
        } else {
          reject('Failed to retrieve session data.'); // Hata durumunda reject ile hata döndür.
        }
      });
    });
  }
  setComparisonData(data) {
    this.comparisonData = data;
    this.comparisonDataListener.emit(this.comparisonData);
  }

  setFavList(id: number): void {
    if (this.favList.includes(id)) {
      this.favList = this.favList.filter(item => item !== id);
    } else {
      this.favList = [...this.favList, id];
    }
    this.favListListener.emit();

    localStorage.setItem('favList', JSON.stringify(this.favList));
  }

  setFavFixtureData(data: { fixture: any[]; disabledMatchIdList: number[] }): void {
    if (data?.fixture.length > 0) {
      this.favFixtureList = data.fixture;
      this.setFavListListener.emit();
    } else {
      this.favFixtureList = [];
      this.setFavListListener.emit();
    }

    if (this.favList.length > 0 && data?.disabledMatchIdList.length > 0) {
      this.favDisabledMatchId = data?.disabledMatchIdList;
    }
  }

  setMySlipMatchList(matchList: number[]) {
    this.mySlipMatchList = matchList;
    this.mySlipMatchListListener.emit();
  }

  setIsMySlipButton(x: boolean) {
    if (environment.isMySlipLive && this.isMySlipButton !== x) {
      this.isMySlipButton = x;
      this.isMySlipButtonListener.emit();
    }
  }
  setBetAmounts() {
    if (environment.isBetSettings) {
      const savedAmounts = JSON.parse(localStorage.getItem('betAmounts'));
      if (savedAmounts) {
        this.default_amount_arr = savedAmounts;
      }
      const savedStakeAmount = JSON.parse(localStorage.getItem('savedStakeAmount'));
      const lastStakeAmount = JSON.parse(localStorage.getItem('lastStakeAmount'));

      if (savedStakeAmount) {
        this.currentSlipInfo.currentslip_totalStake = parseFloat(savedStakeAmount);
      } else if (lastStakeAmount) {
        this.currentSlipInfo.currentslip_totalStake = parseFloat(lastStakeAmount);
      } else {
        this.currentSlipInfo.currentslip_totalStake = DefaultSlipAmount;
      }
    } else {
      this.currentSlipInfo.currentslip_totalStake = DefaultSlipAmount;
    }
  }
}
